import { NgModule } from "@angular/core";
import { InfoportalApiRoutingModule } from "./routing.module";
import { InfoportalApiComponent } from "./infoportal-api.component";
import { InfoportalApiNavigationComponent } from "./navigation/infoportal-api-navigation.component";
import { InfoportalApiElevatorOverviewComponent } from "./infoportal-api-elevators/overview/elevators-overview.component";
import { InfoportalApiCustomerOverviewComponent } from "./infoportal-api-customers/overview/customers-overview.component";
import { CommonComponentsModule } from "../common-components";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { InfoportalApiSelectCustomerComponent } from "./infoportal-api-selects/infoportal-api-select-customer/infoportal-api-select-customer.component";
import { InfoportalApiElevatorDetailComponent } from "./infoportal-api-elevators/detail/elevators-detail.component";
import { InfoportalApiCustomerSearchComponent } from './infoportal-api-customers/search/customers-search.component';
import { WartungshistoryComponent } from './wartungshistory-timeline/wartungshistory.component';
import { FacilityOverviewComponent } from "./components/facilities/facility-overview/facility-overview.component";
import { FacilityMasterDataComponent } from "./components/facilities/facility-masterdata/facility-masterdata.component";
import { WartungshistoryExtendedFilterComponent } from "./wartungshistory-timeline/wartungshistory-extended-filter/wartungshistory-extended-filter.component";
import { ProcessOverViewComponent } from "./components/processes/process-overview/process-overview.component";
import { InfoportalFolderCreateComponent } from "./components/processes/insert/folder-create.component";
import { InfoportalFolderUpdateComponent } from "./components/processes/update/folder-update.component";
import { InfoportalDocumentCreateComponent } from "./components/documents/insert/document-create.component";
import { InfoportalDocumentUpdateComponent } from "./components/documents/update/document-update.component";
import { InfoportalSelectTagsComponent } from "./components/tags/tags-select/tags-select.component";
import { InfoportalNotesFacilityOverviewComponent } from "./components/notes-facility/overview/notes-facility.component";
import { InfoportalAppEndcustomerUserCreateComponent } from "./infoportal-api-customers/endcustomer-users/create/endcustomer-user-create.component";
import { InfoportalApiEndCustomerUserOverviewComponent } from "./infoportal-api-customers/endcustomer-users/overview/endcustomer-user-overview.component";
import { InfoportalApiFolderFilterPopupComponent } from "./components/processes/process-overview/filter-popup/folders-filter-popup.component";
import { AnlageApiComponentsModule } from "../anlage-api/components/anlage-components.module";
import { InfoportalApiPagesModule } from "./pages/infoportal-pages.module";
import { InfoportalApiComponentsModule } from "./components/infoportal-components.module";
import { InfoportalApiElevatorDisplayNotesComponent } from "./infoportal-api-elevators/display-notes/elevators-displayNotes.component";
import { InfoportalApiElevatorDisplayWartungshistoryComponent } from "./infoportal-api-elevators/display-wartungshistory/elevators-displayWartungshistory.component";
import { InfoportalApiCustomerFacilitiesManagePopupComponent } from "./infoportal-api-customers/customer-facilities-manage/popup/customer-facilities-manage-popup.component";
import { InfoportalApiCustomerFacilitiesManageComponent } from "./infoportal-api-customers/customer-facilities-manage/component/customer-facilities-manage.component";
import { WawiApiAddressesModule } from "../wawi-api/addresses/addresses.module";
import { CstFolderDocumentTreeComponent } from "../common-components/folder-document-tree/component/folder-document-tree.component";

@NgModule({ declarations: [
        InfoportalApiComponent,
        InfoportalApiNavigationComponent,
        InfoportalApiElevatorOverviewComponent,
        InfoportalAppEndcustomerUserCreateComponent,
        InfoportalApiEndCustomerUserOverviewComponent,
        InfoportalApiCustomerOverviewComponent,
        InfoportalApiCustomerFacilitiesManageComponent,
        InfoportalApiCustomerFacilitiesManagePopupComponent,
        InfoportalApiElevatorDetailComponent,
        InfoportalApiSelectCustomerComponent,
        InfoportalApiCustomerSearchComponent,
        WartungshistoryComponent,
        FacilityOverviewComponent,
        InfoportalNotesFacilityOverviewComponent,
        FacilityMasterDataComponent,
        WartungshistoryExtendedFilterComponent,
        ProcessOverViewComponent,
        InfoportalApiFolderFilterPopupComponent,
        InfoportalFolderCreateComponent,
        InfoportalFolderUpdateComponent,
        InfoportalDocumentCreateComponent,
        InfoportalDocumentUpdateComponent,
        InfoportalSelectTagsComponent,
        InfoportalApiElevatorDisplayNotesComponent,
        InfoportalApiElevatorDisplayWartungshistoryComponent,
    ],
    exports: [
        InfoportalApiElevatorOverviewComponent,
        InfoportalApiCustomerOverviewComponent,
        InfoportalApiCustomerSearchComponent,
        InfoportalApiSelectCustomerComponent,
        WartungshistoryComponent,
        FacilityOverviewComponent,
        FacilityMasterDataComponent,
        WartungshistoryExtendedFilterComponent,
        ProcessOverViewComponent,
        InfoportalFolderCreateComponent,
        InfoportalFolderUpdateComponent,
        InfoportalDocumentCreateComponent,
        InfoportalDocumentUpdateComponent,
        InfoportalSelectTagsComponent,
        InfoportalApiElevatorDisplayNotesComponent,
        InfoportalApiElevatorDisplayWartungshistoryComponent,
    ], imports: [CommonComponentsModule,
        InfoportalApiRoutingModule,
        AnlageApiComponentsModule,
        CstFolderDocumentTreeComponent,
        InfoportalApiPagesModule,
        InfoportalApiComponentsModule,
        WawiApiAddressesModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class InfoportalApiModule { }
